import {
  SettingsPanelTabName,
  SidePanelTabName,
} from '../../../team-apis/core/side-panel';

export class SidePanelState {
  annotationPanelState: 'annotation_list' | 'class_selector' =
    'annotation_list';
  selectedTabName: SidePanelTabName = 'annotation';
  selectedSettingsTabName?: SettingsPanelTabName;
}
